import { inject, Injectable } from '@angular/core';
import { WebtoolsChangelogVersion } from '../model/webtools-changelog-version';
import { Observable, tap } from 'rxjs';
import { WebtoolsChangelogVersionFactory } from '../factory/webtools-changelog-version-factory';
import {
  DataModel,
  HttpFilter,
  ModelProperty,
  NameValue,
  RestService,
} from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private restService = inject(RestService);

  public model: DataModel;
  public versionArray: WebtoolsChangelogVersion[] = [];

  public generateModel$() {
    return this.restService
      .options(new WebtoolsChangelogVersionFactory().getApi())
      .pipe(
        tap((model) => {
          const statusProperty = model.find('status');
          if (statusProperty) {
            statusProperty.existOnTable = false;
            const statusLabelProperty = this.getStatusLabelProperty(
              statusProperty.position,
            );
            statusLabelProperty.showOnForm = false;
            model.addProperty(statusLabelProperty);
          }
          this.model = model;
        }),
      );
  }

  public putRequest$(version: WebtoolsChangelogVersion) {
    return this.restService.put(
      new WebtoolsChangelogVersionFactory().getApi(),
      version.serialize(),
    );
  }

  public postRequest$(version: WebtoolsChangelogVersion) {
    return this.restService.post(
      new WebtoolsChangelogVersionFactory().getApi(),
      version.serialize(),
    );
  }

  public deleteRequest$(version: WebtoolsChangelogVersion) {
    return this.restService.delete(
      new WebtoolsChangelogVersionFactory().getApi(),
      version.getId(),
    );
  }

  private getStatusLabelProperty(position: number): ModelProperty {
    const prop = new ModelProperty('statusLabel', 'Statut');
    prop.formatter = {
      type: 'icon',
      field: 'status',
      displayText: true,
      values: {
        D: 'flag fas warning',
        P: 'flag fas success',
      },
    };
    prop.position = position;
    return prop;
  }

  public callVersions$(
    product: string,
  ): Observable<WebtoolsChangelogVersion[]> {
    const filters = [new NameValue('with', `product|=|${product}`)];
    return this.restService
      .getAll(new WebtoolsChangelogVersionFactory(), {
        httpFilter: new HttpFilter(filters),
      })
      .pipe(
        tap((versions) => {
          this.versionArray = versions;
        }),
      );
  }
}
